import React from 'react';
import { BeatLoader } from 'react-spinners';
import { Card } from '../../../base-components/Card.js';
import { Typograf } from '../../../base-components/Typograf.js';
import { pluralFound } from '../../../utils/format.js';
import { typograf } from '../../../utils/format.js';
import { integer } from '../../../utils/format.js';
import { pluralPurchases } from '../../../utils/format.js';
import { FormSelectSortBy } from '../components/SelectSortBy/FormSelectSortBy.js';
import { FormSortOrderSwitch } from '../components/SortOrderSwitch/FormSortOrderSwitch.js';
import { SortByOption } from '../types.js';
import styles from './Stats.module.scss';

interface Props {
  total: number;
  referenceSortByOptions: SortByOption[];
  isLoading: boolean;
}

export const Stats: React.FC<Props> = ({
  total,
  referenceSortByOptions,
  isLoading,
}) => (
  <div className={styles.card}>
    <div>
      <Typograf component="div">
        {typograf.execute(
          [
            `По Вашему запросу`,
            pluralFound(total),
            integer(total),
            pluralPurchases(total),
          ].join(' '),
        )}
      </Typograf>
    </div>
    <div>{isLoading && <BeatLoader color="#2d9cdb" />}</div>
    <div className={styles.sortBy}>
      <span className={styles.label}>Сортировать по</span>
      <FormSelectSortBy
        name="sortBy"
        className={styles.button}
        options={referenceSortByOptions}
      />
      <FormSortOrderSwitch name="sortOrder" className={styles.icon} />
    </div>
  </div>
);
